import {withKnownRoute} from '../../lib/routes';
import {SpellsPage} from './spells-page';

export default withKnownRoute(SpellsPage);
